<template>
  <div>
    <!-- Tabs -->
    <v-card-text
      class="bg-gray-dark px-6 py-0 pt-3 text-nitro"
    >
      <div
        class=" d-flex justify-content-center"
        style="width: 300px"
      >
        <span
          class="pointer-on-hover p-2 text-center"
          :class="{
            'bg-white': type == 'month'
          }"
          style="width: 48%; border-radius: 5px 5px 0px 0px; font-size: 16px;"
          @click="type = 'month'"
        >
          Mês 
        </span>
        <span
          class="pointer-on-hover p-2 text-center"
          :class="{
            'bg-white': type == 'week'
          }"
          style="width: 48%; border-radius: 5px 5px 0px 0px; font-size: 16px;"
          @click="type = 'week'"
        >
          Semana 
        </span>
      </div>
    </v-card-text>
    <!-- tabs -->
    <v-container fluid>
      <v-row>
        <v-col
          cols="12"
          class="d-flex align-items-center text-black"
        >
          <span class="d-flex justify-content-start align-items-center mr-6" style="width: 260px">
            <span
              style="width: 32px; height: 32px;"
              class="pointer-on-hover p-2 rounded-circle border d-flex justify-content-center align-items-center border-black"
              @click="$refs.calendar.prev()"
            >
              <i
                class="fas  fa-chevron-left "
              />
            </span>
            <div class="py-4 text-secondary">
              <span class="mx-2 text-black">
                {{ months[Number(value.split('-')[1]) - 1] }} de {{ value.split('-')[0] }}
              </span>
            </div>
            <span
              style="width: 32px; height: 32px;"
              class="pointer-on-hover p-2 rounded-circle border d-flex justify-content-center align-items-center border-black"
              @click="$refs.calendar.next()"
            >
              <i
                class="fas  fa-chevron-right "
              />
            </span>
            
          </span>
          <CreateSchedule @closeModal="getEvents()" />
        </v-col>
        <v-col md="12">
          <v-sheet height="600">
            <EventsCalendar v-if="$vuetify.mobile" />
            <v-calendar
              v-else
              ref="calendar"
              v-model="value"
              color="nitro"
              :weekdays="weekdays"
              :type="type"
              :events="[...cycle_events, ...events]"
              :event-color="getEventColor"
              :event-category="getEventCategory"
              :interval-format="intervalFormat"
            />
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

import { months } from "@/constants/months";
import {getEventCategory, getEventColor, intervalFormat } from "@/common/utils/calendarHelpers";
import CreateSchedule from "@/student/pages/calendar/components/CreateSchedule";
import {mapActions, mapGetters} from "vuex";
import EventsCalendar from "@/student/components/calendar/EventsCalendar";

export default {
  components: {
    CreateSchedule,
    EventsCalendar,
  },
  data: () => ({
    months,
    tab: 0,
    scrollStartTime: '07:30',
    type: 'month',
    value: '',
    weekdays: [0,1,2,3,4,5,6],
  }),
  computed: {
    ...mapGetters(['events','cycle_events'])
  },
  watch: {
    type: {
      handler(new_type) {
        if (new_type == "week"){
          this.$nextTick(() => {
            this.$refs.calendar.scrollToTime(this.scrollStartTime);
          })
        }
      },
      immediate: true
    },

  },
  created() {
    this.getEvents();
    this.value = this.$moment().format('Y-MM-DD')
  },
  methods: {
    ...mapActions(['getEvents']),
    getEventColor,
    getEventCategory,
    intervalFormat
  },
}
</script>
<style lang="scss">
// Deixa a cor dos eventos de estudo com outlined
div.v-event.v-event-start.v-event-end.theme{
  color: #06017a !important;
  border: solid 1px #06017a !important;
  background-color: white !important;
}

div.v-calendar-weekly__day.v-present > div > button {
  color: white;
}
</style>